import { FiTaskV2CompletedByShortComponent } from '../fi-task-v2-list-item/fi-task-v2-completed-by-short/fi-task-v2-completed-by-short.component';
import { FiTaskV2AssigneeShortComponent } from '../fi-task-v2-list-item/fi-task-v2-assignee-short/fi-task-v2-assignee-short.component';
import { FiTaskV2SharedComponentsModule } from '../components/fi-task-v2-shared-components.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiChecklist2ListColumnDefsModule } from '@fi-shared/checklist/fi-checklist2-list-column-defs/fi-checklist2-list-column-defs.module';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatIconModule } from '@angular/material/icon';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';

import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { MatButtonModule } from '@angular/material/button';

import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';
import { FiProfileIconStackedModule } from '@fi-shared/fi-profile-icon-stacked/fi-profile-icon-stacked.module';
import { FiTwoColumnsContainerModule } from '@fi-shared/fi-two-columns-container/fi-two-columns-container.module';
import { FiEmptyListModule } from '@fi-shared/fi-empty-list/fi-empty-list.module';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { FiTaskV2ListComponent } from './fi-task-v2-list.component';
import { FiTaskV2ListItemComponent } from '../fi-task-v2-list-item/fi-task-v2-list-item.component';
import { FiTaskV2ListHelperService } from './fi-task-v2-list-helper.service';
import { FiTooltipModule } from '@fi-shared/fi-tooltip/fi-tooltip.module';

@NgModule({
    imports: [
        CommonModule,
        FiAppTextSharedModule,
        FiChecklist2ListColumnDefsModule,
        FiItemsListModule,
        FiLocalSearch2Module,
        FiWrapperTableModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        FiWhenScrolledModule,
        FiFormatDateModule,
        FiTaskV2SharedComponentsModule,
        MatDividerModule,
        FiProfileIconModule,
        InfoIconModule,
        FiProfileIconStackedModule,
        FiTwoColumnsContainerModule,
        FiEmptyListModule,
        FiLoadingModule,
        FiTooltipModule,
    ],
    providers: [FiTaskV2ListHelperService],
    declarations: [
        FiTaskV2ListComponent,
        FiTaskV2ListItemComponent,
        FiTaskV2AssigneeShortComponent,
        FiTaskV2CompletedByShortComponent,
    ],
})
export class FiTaskV2ListModule {}
